import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const AdminConfig = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_ALL_CITY_CONFIGS:
      return { ...state, allCityConfigs: action.value };
    case actions.FETCH_CITY_AGENCIES:
      return { ...state, cityAgencies: action.value };
    case actions.UPSERT_CITY_CONFIGS:
      return { ...state, createCityConfigResponse: action.value };
    default:
      return state;
  }
};

export default AdminConfig;
